import AnalyticsAggregator from './AnalyticsAggregator';

const analytics = new AnalyticsAggregator();

export default analytics;
